import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-702a316e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "clothe" }
const _hoisted_4 = { class: "general-section" }
const _hoisted_5 = { class: "body body--space-evenly" }
const _hoisted_6 = { class: "address" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "address-head" }, "地點：", -1))
const _hoisted_8 = { class: "address-body" }
const _hoisted_9 = {
  key: 0,
  class: "address-city"
}
const _hoisted_10 = { class: "address-content" }
const _hoisted_11 = { class: "tail" }
const _hoisted_12 = {
  key: 0,
  class: "entity-info"
}
const _hoisted_13 = { class: "total-hrs" }
const _hoisted_14 = { class: "periods" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "periods-head" }, "時間：", -1))
const _hoisted_16 = { class: "periods-body" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "ads-info"
}
const _hoisted_19 = {
  key: 0,
  class: "post-deadline"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最後發文時間：", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "common-info" }, null, -1))
const _hoisted_22 = { class: "personal-section" }
const _hoisted_23 = {
  key: 0,
  class: "expect"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expect-head" }, "本次預計薪資：", -1))
const _hoisted_25 = { class: "expect-body" }
const _hoisted_26 = {
  key: 1,
  class: "info"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode("查看資訊")
const _hoisted_28 = {
  key: 2,
  class: "action"
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode("審核中")
const _hoisted_30 = {
  key: 3,
  class: "action"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_32 = {
  key: 4,
  class: "action",
  style: {"margin-top":"10px"}
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode("我要報到")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_JobDetailVue = _resolveComponent("JobDetailVue")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "job-list-item",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args)))
    }, [
      _renderSlot(_ctx.$slots, "head", {}, () => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["job-category-tag", {
            '--bg-blue': _ctx.job.category === '實體活動',
            '--bg-purple': _ctx.job.category === '業配',
          }])
          }, _toDisplayString(_ctx.job.category), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["job-category-tag", {
            '--bg-green': _ctx.job.priceType === '互惠',
            '--bg-pink': _ctx.job.priceType === '收費',
          }])
          }, _toDisplayString(_ctx.job.priceType), 3),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.job.title), 1)
        ])
      ], true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.job.category === '實體活動' && (_ctx.job.city || _ctx.job.address))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      (_ctx.job.city)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.job.city), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.job.address), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _renderSlot(_ctx.$slots, "body", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.job.category === '實體活動')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _renderSlot(_ctx.$slots, "entity", {}, () => [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.job.entityInfo.totalHrs) + "H", 1),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.job.entityInfo.time), 1),
                        (_ctx.job.entityInfo.hasMutiplePeriods)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "..."))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.job.category === '業配')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_ctx.job.adsInfo.postTime)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("span", null, _toDisplayString(_ctx.job.adsInfo.postTime), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _hoisted_21,
            _renderSlot(_ctx.$slots, "tail", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), undefined, true)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _renderSlot(_ctx.$slots, "personal", _normalizeProps(_guardReactiveProps(_ctx.slotProps)), () => [
            ([1, 2].includes(_ctx.personalJobType))
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.job.myPay), 1)
                ]))
              : _createCommentVNode("", true),
            ([3].includes(_ctx.personalJobType))
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_component_a_button, { style: {"border-radius":"5px"} }, {
                    default: _withCtx(() => [
                      _hoisted_27
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.personalJobType === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createVNode(_component_a_button, { disabled: "" }, {
                    default: _withCtx(() => [
                      _hoisted_29
                    ]),
                    _: 1
                  })
                ]))
              : (_ctx.personalJobType === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.showDetail
                    }, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : (_ctx.personalJobType === 3 && _ctx.job.category === '實體活動')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _withModifiers(_ctx.showIdentity, ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _hoisted_33
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
          ], true)
        ])
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.isDetailVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isDetailVisible) = $event)),
      footer: "",
      closable: !_ctx.isPersonal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_JobDetailVue, {
          trackingNumber: _ctx.job.trackingNumber,
          isPersonal: _ctx.isPersonal,
          onClose: _ctx.closeDetail,
          onOnRegister: _ctx.onRegister
        }, null, 8, ["trackingNumber", "isPersonal", "onClose", "onOnRegister"])
      ]),
      _: 1
    }, 8, ["visible", "closable"])
  ], 64))
}